//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
// import rafLoop from 'raf-loop'
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import LazyHydrate from 'vue-lazy-hydration';
// const cloneDeep = require('lodash.clonedeep');

export default
{
	components:
	{
		// LazyHydrate,
	},

	props:
	{
		// count:
		// {
		// 	type: Number,
		// 	default: 1
		// },
		// keys:
		// {
		// 	type: Array,
		// 	default() { return [] }
		// },

		items:
		{
			type: Array,
			default: null
		},

		itemClass:
		{
			type: Object,
			default: () => ({})
		},

		itemStyle:
		{
			type: Object,
			default: () => ({})
		},

		pixelOffset:
		{
			type: Number,
			default: 0
		},

		offsetMarginSelector:
		{
			type: String,
			default: ''
		},

		// perPage:
		// {
		// 	type: Number,
		// 	default: 1
		// },

		keyProp:
		{
			type: String,
			default: 'id'
		},

		transition:
		{
			type: String,
		},

		allowDuplicates:
		{
			type: Boolean,
			default: true,
		}
	},

	data()
	{
		return {
			marginOffset: 0,
			carouselOffsetX: 0,
			prevTouchX: 0,
			isPanning: false,
			isTransitioning: false,
			isTransitioningToIndex: -1,
			momentumDuration: 1,
			raf: null,
			velocity: 0,
			deceleration: 0.8,
			restOffsetX: 0,
			restDistanceX: 0,
			currentSlideIndex: 0,
			// currentPage: 0,
			// pageCount: 0,
			onTransitionEndCallback: null,
			startPos: {
				x: 0,
				y: 0
			},

			pageCount: 1,

			isScrollable: true,

			onResizeHandler: null,
		}
	},

	computed:
	{
		...mapGetters(['isEditingPage']),
		carouselContentStyle()
		{
			return `transform: translate3d(${this.carouselOffsetX}px, 0px, 0px)`;
		},

		carouselSlideStyle()
		{
			return {...this.itemStyle, };
			// return {...this.itemStyle, 'pointer-events': this.isEditingPage ? 'all' : 'none'};
		},

		// pageCount()
		// {
		// 	return Math.ceil( this.items.length / this.perPage );
		// },

		perPage()
		{
			return Math.floor( this.items.length / this.pageCount );
		},

		currentPage()
		{
			return Math.floor(this.currentSlideIndex / this.perPage)
		},

		// _keys()
		// {
		// 	if (this.keys)	return this.keys
		// 	return Array(this.count).fill(0).map((x, idx) => idx)
		// }
	},

	watch:
	{
		items(newVal)
		{
			consola.debug('carousel items changed: ', newVal.length)
			this.$nextTick( () =>
			{
				this.currentSlideIndex = -1;
				this.onResize()
				var offset = this.calcLeftOffset();
				this.moveToLeftOffset(offset)
				// this.calcSnapPosition()
			} )

		},

		isScrollable(newVal)
		{
			if (this.$refs.container &&
				this.$refs.container.hammer &&
				this.$refs.container.hammer.set)
			{
				this.$refs.container.hammer.set({ enable: newVal })
			}
		},

		pixelOffset(newVal)
		{
			this.marginOffset = newVal;
		},

		offsetMarginSelector(newVal)
		{
			this.calcMargin(newVal)
		}

		// currentSlideIndex(newVal)
		// {
		// 	consola.debug('currentSlideIndex: ', newVal)
		// }
	},

	// beforeMount()
	// {
	// 	// this.restOffsetX = this.pixelOffset;
	// 	this.restDistanceX  = this.pixelOffset;
	// 	// this.carouselOffsetX = this.pixelOffset;
	// },

	mounted()
	{
		// consola.debug('$scopedSlots: ', this.$scopedSlots.default );
		// consola.debug('$slots: ', this.$slots );
		// consola.debug('$refs: ', this.$refs );

		const self = this;

		this.marginOffset = this.pixelOffset;
		this.calcMargin(this.offsetMarginSelector);

		this.restDistanceX  = this.marginOffset;

		consola.debug('carousel items: ', this.items)

		this.$nextTick( () =>
		{
			if ( !this.$refs.wrapper || !this.$refs.wrapper.firstChild )	return;
			const mc = this.$refs.wrapper.firstChild.hammer;
			// consola.debug('hammer mc: ', mc);
			// mc.set({ domEvents: true })
			// mc.remove('panup')
			// mc.remove('pandown')

			const pan = mc.get('pan')
			const DIRECTION_HORIZONTAL = 6
			pan.set({ direction: DIRECTION_HORIZONTAL })
			this.calcPage();
		} )

		// this.raf = rafLoop(function(dt)
		// {
		// 	self.updatePos(dt);
		// });
		this.$raf.on('tick', this.updatePos)
		if (process.browser)
		{
			this.onResizeHandler = this.onResize.bind(this);
			window.addEventListener('resize', this.onResizeHandler )
		}

		setTimeout(() => {
			this.onResize()
		}, 1000);
	},

	beforeDestroy()
	{
		if (process.broswer)
		{
			window.removeEventListener('resize', this.onResizeHandler);
		}
	},


	methods:
	{
		getKey(item, index)
		{
			if (!item)	return index;
			if (this.allowDuplicates)
				return index + '_' + item[this.keyProp]
			else
				return item[this.keyProp]
		},

		onResize()
		{
			this.pageCount = this.calcPageCount();

			if (this.offsetMarginSelector)
			{
				this.calcMargin(this.offsetMarginSelector)
			}
		},

		calcMargin(sel)
		{
			if (process.browser && sel)
			{
				var el = document.querySelector(sel);
				if (el)
				{
					var style = el.currentStyle || window.getComputedStyle(el);
					this.marginOffset = parseFloat(style.marginLeft);
				}
			}
		},

		refreshSlides()
		{
			this.$nextTick( ()=>
			{
				consola.debug('refreshSlides()')
				// // this.$forceUpdate();
				// // this.$raf.removeListener('tick', this.updatePos)
				// // this.$raf.addListener('tick', this.updatePos)
				// // this.updatePos(0)
				// this.currentSlideIndex = 999999;
				// this.isTransitioning = false;
				// this.isTransitioningToIndex = -1;
				// // this.calcSnapPosition();
				// this.goto(0);
				// this.currentSlideIndex = this.recalcCurrentSlideIndex();
				// // this.gotoPrev();

				this.onResize()
				var offset = this.calcLeftOffset();
				this.moveToLeftOffset(-offset)
				this.currentSlideIndex = 0;
				this.onTransitionEndCallback = () =>
				{
					this.currentSlideIndex = 0;
					this.isTransitioning = false;
					this.isTransitioningToIndex = -1;
				};
				// this.currentSlideIndex = 0;
				// this.isTransitioning = false;
				// this.isTransitioningToIndex = 0;
			} )
		},

		calcPage()
		{
			// const contRect = this.$refs.container.getBoundingClientRect();
			// this.pageCount = Math.ceil(contRect.width / this.$refs.mainCarousel.clientWidth);
			// this.currentPage = ((-contRect.left + this.pixelOffset) / this.$refs.mainCarousel.clientWidth);
			// consola.debug('page: ', this.currentPage)
			// this.currentPage = Math.max(0, this.currentPage);
		},

		calcPageCount()
		{
			if (!this.$refs.wrapper || !this.$refs.container)
				return 1;

			var wrapperBox = this.$refs.wrapper.getBoundingClientRect();
			var contentBox = this.$refs.container.getBoundingClientRect();

			const wrapperWidth = wrapperBox.width - this.marginOffset*2;
			const ratio = contentBox.width / wrapperWidth;
			var pageCount = Math.ceil(ratio);

			this.isScrollable = ratio > 1;

			if ( Number.isNaN(pageCount) )	return 1;

			return pageCount;
		},

		// positive when inside the wrapperBox, negative when on the left(outside) of the wrapperBox
		calcLeftOffset(wrapperBox, contentBox)
		{
			var wrapperBox = wrapperBox || this.$refs.wrapper.getBoundingClientRect();
			var contentBox = contentBox || this.$refs.container.getBoundingClientRect();

			const offset = contentBox.left - (wrapperBox.left + this.marginOffset);
			return offset;
		},

		// positive when inside the wrapperBox, negative when on the right(outside) of the wrapperBox
		calcRightOffset(wrapperBox, contentBox)
		{
			var wrapperBox = wrapperBox || this.$refs.wrapper.getBoundingClientRect();
			var contentBox = contentBox || this.$refs.container.getBoundingClientRect();

			const offset = (wrapperBox.right - this.marginOffset) - contentBox.right;
			return offset;
		},

		calcSnapOffset(extraOffset)
		{
			extraOffset = extraOffset || 0;
			let finalLeftOffset = 0;
			let left = this.calcLeftOffset() + extraOffset;
			let right = 0;

			if (left > 0)
			{
				// the left side is inside the wrapperBox
				finalLeftOffset = -left;
				// consola.debug('left side is inside the wrapperBox: ', finalLeftOffset)
			}
			else if (left < 0)
			{
				// the left side is outside the wrapperBox
				right = this.calcRightOffset() - extraOffset;

				if (right > 0)
				{
					// the right side is inside the wrapperBox
					finalLeftOffset = Math.min(-left, right);
					// consola.debug('right side is inside the wrapperBox: ', finalLeftOffset)
				}
				else if (right < 0)
				{
					// the right side is outside the wrapperBox
					// calculate the Slide snapping here
					// consola.debug('right side is outside the wrapperBox: ', finalLeftOffset)
				}
			}

			return finalLeftOffset;
		},

		calcSnapPosition(event)
		{
			this.velocity = event ? event.overallVelocityX : 1;
			var minIndex = -1;
			let minDist = 1000000000;
			// debugger;
			// const b = this.$refs.mainCarousel.getBoundingClientRect();
			const b = this.$refs.wrapper.getBoundingClientRect();
			// const contRect = this.$refs.container.getBoundingClientRect();

			let carousel = { left: b.left, right: b.right, top: b.top, bottom: b.bottom }
			// this.currentPage = Math.floor(carousel.left / b.width);
			carousel.left += (this.marginOffset);
			for (let i = 0; i < this.$refs.wrapper.firstChild.childNodes.length; i++)
			{
				let bbox = this.$refs.wrapper.firstChild.childNodes[i].getBoundingClientRect();
				if (Math.abs((bbox.left - bbox.width*0.0) - carousel.left) < Math.abs(minDist))
				{
					// if (this.velocity < 0 && (bbox.left - carousel.left) > minDist)
					// {

					// }
					minDist = bbox.left - carousel.left;
					minIndex = i;
					this.currentSlideIndex = i;
				}
			}

			if (this.velocity < 0 && minDist < 0)
			{
				let idx = Math.min(this.$refs.wrapper.firstChild.childNodes.length - 1, minIndex + 1)
				if (idx > minDist)
				{
					let bbox = this.$refs.wrapper.firstChild.childNodes[idx].getBoundingClientRect();
					minDist = bbox.left - carousel.left;
					minIndex = idx;
					this.currentSlideIndex = idx;
				}
			}
			else if (this.velocity > 0 && minDist > 0)
			{
				let idx = Math.max(0, minIndex - 1)
				if (idx < minDist)
				{
					let bbox = this.$refs.wrapper.firstChild.childNodes[idx].getBoundingClientRect();
					minDist = bbox.left - carousel.left;
					minIndex = idx;
					this.currentSlideIndex = idx;
				}
			}

			if (minIndex == -1)
				minDist = 0

			let finalLeftOffset = this.calcSnapOffset();

			if ( finalLeftOffset==0 )
				finalLeftOffset = -minDist;

			this.restOffsetX = finalLeftOffset;
			this.restDistanceX = finalLeftOffset;
			// this.restOffsetX = -minDist;
			// this.restDistanceX = -minDist;
			this.prevTouchX = this.carouselOffsetX;

			// let page = Math.ceil( (contRect.left-minDist - this.marginOffset) / this.$refs.mainCarousel.clientWidth);
			// page = Math.min(page, 0)
			// this.currentPage = Math.abs( page );
			// consola.debug('minDist: ', minDist)
			// consola.debug('contRect.left: ', contRect.left)
			// consola.debug('currentPage: ', this.currentPage)

			// consola.debug(`calcSnapPosition: restOffsetX[${this.restOffsetX}] currentSlideIndex[${this.currentSlideIndex}]`);
		},

		updatePos(dt)
		{
			this.velocity *= this.deceleration;
			this.restOffsetX *= this.deceleration;
			this.carouselOffsetX = this.prevTouchX - (this.restOffsetX - this.restDistanceX);
			// consola.debug('this.carouselOffsetX: ', this.carouselOffsetX)
			// if (Number.isNaN(this.carouselOffsetX))
			// {
			// 	debugger;
			// }
			if ( this.restOffsetX < 0.1 * this.restDistanceX )
			{
				if ( this.onTransitionEndCallback )
				{
					this.onTransitionEndCallback();
					this.onTransitionEndCallback = null;
				}
			}

			if ( Math.round(this.restOffsetX) == 0 )
			{
				this.carouselOffsetX = Math.round( this.carouselOffsetX );

				// consola.debug('remove updatePos')
				// this.raf.stop();
				this.$raf.removeListener('tick', this.updatePos)
				this.calcPage();
				// consola.debug('raf stop');
			}

			// consola.debug('updatePos restOffsetX: ', this.restOffsetX)
		},

		moveToLeftOffset(offset)
		{
			this.restOffsetX = offset;
			this.restDistanceX = offset;
			this.prevTouchX = this.carouselOffsetX;
			// consola.debug('moveDist: ', moveDist)
			// this.raf.start();
			this.$raf.removeListener('tick', this.updatePos)
			this.$raf.addListener('tick', this.updatePos)
		},

		goto(index)
		{
			// if (this.is)
			const i = Math.min( Math.max(index, 0), this.$refs.wrapper.firstChild.childNodes.length - 1);

			// debugger;

			if (this.currentSlideIndex == i || this.isTransitioningToIndex == i)
				return;

			this.isTransitioning = true;
			this.isTransitioningToIndex = i;


			// let firstSlideBbox = this.$refs.wrapper.firstChild.childNodes[0].getBoundingClientRect();
			// let slideBbox = this.$refs.wrapper.firstChild.childNodes[i].getBoundingClientRect();


			// let finalLeftOffset = this.calcSnapOffset(slideBbox.left - firstSlideBbox.left);

			// if ( finalLeftOffset==0 )
			// {

			// }

			const carousel = this.$refs.mainCarousel.getBoundingClientRect() ;
			let containerBbox = this.$refs.wrapper.firstChild.getBoundingClientRect();
			let slideBbox = this.$refs.wrapper.firstChild.childNodes[i].getBoundingClientRect();
			let leftDist = slideBbox.left - (carousel.left + this.marginOffset);
			// leftDist -= Math.ceil(this.restOffsetX);
			// let rightDist = containerBbox.right - (carousel.right - this.marginOffset);
			let rightDist = containerBbox.right - (carousel.right) + this.marginOffset;
			// rightDist -= leftDist;
			// rightDist -= Math.ceil(this.restOffsetX);
			rightDist = Math.floor(rightDist);
			// consola.debug('carousel rightDist: ', rightDist);
			// consola.debug('carousel containerBbox.right: ', containerBbox.right);



			// if (rightDist < 0)
			if (leftDist <= 0 && rightDist < 0)
			{
				if (carousel.width < containerBbox.width)
					leftDist = rightDist ;
				// else
				// 	// leftDist = -leftDist;
				// 	leftDist = rightDist;
				// 	// leftDist = 0;
			}
			else
			{
				if ( rightDist - leftDist <= 0 )
				{
					leftDist -= -(rightDist - leftDist);
				}
			}
			this.onTransitionEndCallback = () =>
			{
				this.currentSlideIndex = i;
				this.isTransitioning = false;
				this.isTransitioningToIndex = -1;
			};



			// consola.debug('this.currentSlideIndex: ', this.currentSlideIndex)

			const moveDist = -leftDist;
			// const moveDist = finalLeftOffset;

			this.moveToLeftOffset(moveDist);


			// consola.debug('goto restOffsetX: ', this.restOffsetX)

			// consola.debug(`goto[${index}]: carouselOffsetX[${Math.floor(this.carouselOffsetX)}] currentSlideIndex[${this.currentSlideIndex}]`);

		},

		gotoPage(idx)
		{
			consola.debug('gotoPage ', idx)
			this.goto(idx * this.perPage)
		},

		recalcCurrentSlideIndex()
		{
			let carouselBbox = this.$refs.mainCarousel.getBoundingClientRect();
			for (let i = 0; i < this.$refs.wrapper.firstChild.childNodes.length; i++)
			{
				let box = this.$refs.wrapper.firstChild.childNodes[i].getBoundingClientRect();
				if (box.right < carouselBbox.left + this.marginOffset)	continue; // outside the left side
				if (box.left > carouselBbox.right - this.marginOffset)	continue; // outside the right side

				if (box.left + box.width*0.5 >= carouselBbox.left + this.marginOffset)
					return i;
			}

			return 0;
		},

		gotoPrev()
		{
			const idx = this.recalcCurrentSlideIndex();
			this.goto(idx - 1);
			// this.goto(this.currentSlideIndex - 1);
		},

		gotoNext()
		{
			const idx = this.recalcCurrentSlideIndex();
			this.goto(idx + 1);
			// this.goto(this.currentSlideIndex + 1);
		},

		// onClick(event)
		// {
		// 	consola.debug('onClick ', event)
		// },

		onMouseDown(event)
		{
			// event.preventDefault();
			// event.stopPropagation();
			this.startPos.x = event.clientX;
			this.startPos.y = event.clientY;
		},

		onMouseMove(event)
		{
			// event.preventDefault();
			// event.stopPropagation();
		},

		onMouseUp(event)
		{
			// event.preventDefault();
			// event.stopPropagation();
			// consola.debug(event)

			function deepFindAnchor(node)
			{
				if (!node || !node.getBoundingClientRect)	return null;

				let bbox = node.getBoundingClientRect();
				if (event.clientX < bbox.left ||
					event.clientX > bbox.right ||
					event.clientY < bbox.top ||
					event.clientY > bbox.bottom
					)
					return null;

				if (node.tagName == "A")
					return node;

				// consola.debug('elem type: ', node.tagName)

				if ( !node.childNodes )	return null;

				for (let i = 0; i < node.childNodes.length; i++)
				{
					let item = node.childNodes[i];
					let result = deepFindAnchor(item);
					if (Number.isInteger(result))	return i;
					if (result)	return result;
				}

				return -1;
				// return null;
			}

			let diffX = Math.abs( event.clientX - this.startPos.x );
			let diffY = Math.abs( event.clientY - this.startPos.y );
			const pixelDist = 10;
			if (diffX < pixelDist && diffY < pixelDist)
			{
				// we consider the user action as a click
				let anchor = deepFindAnchor(this.$refs.container)
				if (Number.isInteger(anchor))
				{
					this.$emit('click-slide', anchor)
				}
				else if (anchor)	anchor.click();
				// let el = document.elementFromPoint(event.clientX, event.clientY);

				// consola.debug('clicked on ', anchor);
			}
		},


		onPanHorizontal(event)
		{
			// consola.debug('onPanHorizontal: ', event)
			const verticalMovement = Math.abs(event.deltaY) > Math.abs(event.deltaX);
			if (this.isPanning && !verticalMovement)
			{
				// prevent accidental pan when scrolling
				this.carouselOffsetX = this.prevTouchX + event.deltaX;
			}
			// this.carouselOffsetX = event.velocityX;
			// consola.debug('carouselOffsetX: ', this.carouselOffsetX)
		},

		onPanStart(event)
		{
			// consola.debug('onPanStart: ', event)
			this.prevTouchX = this.carouselOffsetX;
			this.isPanning = true;
			// this.raf.stop();
			this.$raf.removeListener('tick', this.updatePos)
		},

		onPanEnd(event)
		{
			// consola.debug('onPanEnd: ', event)
			this.isPanning = false;
			this.calcSnapPosition(event);
			// this.raf.start();
			this.$raf.addListener('tick', this.updatePos)
		},

		onPanCancel(event)
		{
			// consola.debug('onPanCancel: ', event)
			this.isPanning = false;
			this.calcSnapPosition(event);
			// this.raf.start();
			this.$raf.addListener('tick', this.updatePos)
		},

		// onPanMove(event)
		// {
		// 	consola.debug('onPanMove: ', event)
		// },

	}
}
